import { XIcon } from 'lucide-react';

import UserIcon from '@/shared/assets/user-icon.svg?react';
import { Avatar, AvatarFallback } from '@/shared/components/ui/avatar';
import { Button } from '@/shared/components/ui/button';

type AddedItemsListTileProps = {
  id: string;
  leading?: React.ReactNode;
  title?: string;
  subtitle?: string;
  children?: React.ReactNode;
};

export const AddedItemsList = ({
  items,
  onRemove,
}: {
  items: AddedItemsListTileProps[];
  onRemove?: (id: string) => void;
}) => {
  return (
    <div className="rounded-xs border border-white/50">
      <ul>
        {items.map((item, index) => (
          <>
            <AddedItemsListTile key={item.id} onRemove={onRemove} {...item} />
            {index !== items.length - 1 && (
              <div className="h-px w-full bg-white/20" />
            )}
          </>
        ))}
      </ul>
    </div>
  );
};

const AddedItemsListTile = ({
  id,
  leading,
  title,
  subtitle,
  onRemove,
  children,
}: AddedItemsListTileProps & { onRemove?: (id: string) => void }) => {
  return (
    <li className="flex flex-row items-center gap-3 px-4 py-3.5" key={id}>
      {leading ?? (
        <Avatar className="size-7">
          <AvatarFallback>
            <UserIcon />
          </AvatarFallback>
        </Avatar>
      )}
      <div className="flex flex-1 flex-col">
        {title && <div className="text-sm">{title}</div>}
        {subtitle && (
          <div className="text-2xs text-custom-grey">{subtitle}</div>
        )}
        {children}
      </div>
      {onRemove && (
        <Button
          type="button"
          onClick={() => onRemove(id)}
          btnType={'icon'}
          className="flex size-5 items-center justify-center rounded-full bg-white"
        >
          <XIcon className="size-4 text-black" />
        </Button>
      )}
    </li>
  );
};
